module.exports = __webpack_public_path__ + "img/youtube.e571414b.svg";